import { render, staticRenderFns } from "./ContentSplitDialog.vue?vue&type=template&id=09b8952a&scoped=true&"
import script from "./ContentSplitDialog.vue?vue&type=script&lang=js&"
export * from "./ContentSplitDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContentSplitDialog.vue?vue&type=style&index=0&id=09b8952a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b8952a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCheckbox,VCol,VRow,VSelect,VTextField})
